import { Grid, Typography } from "@mui/material";

import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Producer, Trackers } from "../types";
import ProducersComponetTrackers from "./ProducersComponetTrackers";
import TextInput from "../../../main/components/TextInput";
import { useEffect } from "react";

const schema = yup.object({
  amount: yup.number().required("Campo obrigatório"),
});

// Defina o tipo para o Resolver
type MyResolver = Resolver<Trackers, yup.InferType<typeof schema>>;

interface EditTrackersUsinaProps {
  uG: {
    components?: {
      trackers?: {
        amount?: number;
        producers: Producer[];
      };
    };
  };
  isEditing: boolean;
  // handleSave: () => void;
  setIsEditing: (value: boolean) => void;
  // handleProducersChange: (
  //   objectName: keyof Components,
  //   updatedProducers: Producer[]
  // ) => void;
  updateStateContent: (
    field: string,
    objectName: string,
    value?: number | string | string[] | Producer[]
  ) => void;
}

const EditModuleUsina: React.FC<EditTrackersUsinaProps> = ({
  uG,
  isEditing,
  setIsEditing,

  // handleProducersChange,
  updateStateContent,
}) => {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,

    formState: { errors },
    watch,
  } = useForm<Trackers>({
    defaultValues: {
      amount: uG?.components?.trackers?.amount || 0,
      producers: uG?.components?.trackers?.producers || [],
    },
    resolver: yupResolver(schema) as MyResolver,
  });
  const data = watch();
  console.log("DADOS DO Trackers:", data);
  type TrackersField = keyof Trackers;

  // Função para converter o valor de string para número e enviar para o pai
  const handleTrackersValueChange = (field: TrackersField, value: string) => {
    const numericValue = value === "" ? undefined : Number(value);
    setValue(field, numericValue);
  };

  //Atualiza os producers
  const handleProducersTrackers = (updatedProducers: Producer[]) => {
    console.log("Dados atualizados de produtores recebidos:", updatedProducers);

    updateStateContent("producers", "trackers", updatedProducers);
  };

  const onSubmit: SubmitHandler<Trackers> = async (data) => {
    console.log("onSubmit acionado no filho:", data);

    // Use a função handleInverterValueChange para manipular a mudança de campo
    handleTrackersValueChange("amount", String(data.amount));

    const producersValue: Producer[] = data.producers || [];

    // array de produtores do estado, tratando 'undefined' como um array vazio
    const existingProducers: Producer[] =
      uG?.components?.trackers?.producers || [];

    // Atualize o estado no componente pai, condicionalmente
    if (uG?.components?.trackers?.amount !== data.amount) {
      updateStateContent("amount", "trackers", data.amount);
    }

    // Converta a quantidade de produtores para um formato aceitável pela função
    const producersValueCount: number = producersValue.length;

    // Atualize o estado no componente pai, condicionalmente
    if (producersValueCount !== existingProducers.length) {
      updateStateContent("producers", "trackers", producersValueCount);
    }

    console.log("Formulário submetido com:", data);
  };
  const amount = watch("amount");

  useEffect(() => {
    console.log(
      "Atualizando amount no componente pai para:",
      getValues("amount")
    );
    updateStateContent("amount", "trackers", getValues("amount"));
  }, [amount]);

  useEffect(() => {
    const producersArray = (getValues("producers") as Producer[]) || [];

    console.log(
      "T - Atualizando producers no componente pai para:",
      producersArray
    );

    updateStateContent("producers", "trackers", producersArray);
  }, [getValues("producers")]);

  return (
    <Grid
      container
      sx={{
        padding: "20px",
        flexDirection: "row",
        display: "flex",
        backgroundColor: "rgba(217, 217, 217, 0.1)",
        borderRadius: 2,
        marginTop: "8px",
        marginBottom: "8px",
        rowGap: "16px ",
        width: "100%",
      }}
      //   onSubmit={handleSubmit(onSubmit)}
    >
      <Grid item xs={6} textAlign={"start"}>
        <Typography>Trackers</Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid
          container
          spacing={2}
          sx={{
            padding: "20px",
          }}
          onSubmit={handleSubmit(onSubmit)}
        >
          {isEditing ? (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"N° de Trackers"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"N° de Trackers"}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
            </>
          )}
          {/* <Button type="submit" onClick={handleSaveAndExitEditMode}>
            Salvar Dados
          </Button> */}
          <ProducersComponetTrackers
            producers={uG?.components?.trackers?.producers || []}
            isEditing={isEditing}
            handleProducersTrackers={handleProducersTrackers}
            setIsEditing={setIsEditing}
            // handleProducersChange={(updatedProducers) => {
            //   handleProducersChange("trackers", updatedProducers);
            // }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditModuleUsina;
